import React, { useState } from "react";
import jsPDF from "jspdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Apply = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    program: "",
    actionsMarks: "",
    subjectGPA: "",
    seeAppearedSchool: "",
    seeAppearedYear: "",
    gpa: "",
    academicInfo: "",
    schoolAddress: "",
    municipality: "",
    province: "",
    religion: "",
    nationality: "",
    dob: "",
    gender: "",
    gradeAppliedFor: "",
    fatherName: "", // New field
    motherName: "", // New field
  });

  const [errors, setErrors] = useState({});
  const [downloaded, setDownloaded] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};
    let formIsValid = true;

    // Basic form validation logic
    if (!formData.name) {
      formIsValid = false;
      newErrors["name"] = "Name is required";
    }

    if (!formData.phone) {
      formIsValid = false;
      newErrors["phone"] = "Phone number is required";
    }

    if (!formData.municipality) {
      formIsValid = false;
      newErrors["municipality"] = "Municipality is required";
    }

    if (!formData.province) {
      formIsValid = false;
      newErrors["province"] = "Province is required";
    }

    if (!formData.religion) {
      formIsValid = false;
      newErrors["religion"] = "Religion is required";
    }

    if (!formData.nationality) {
      formIsValid = false;
      newErrors["nationality"] = "Nationality is required";
    }

    if (!formData.dob) {
      formIsValid = false;
      newErrors["dob"] = "Date of Birth is required";
    }

    if (!formData.gender) {
      formIsValid = false;
      newErrors["gender"] = "Gender is required";
    }

    if (!formData.academicInfo) {
      formIsValid = false;
      newErrors["academicInfo"] = "Academic Info is required";
    }

    if (!formData.seeAppearedSchool) {
      formIsValid = false;
      newErrors["seeAppearedSchool"] = "SEE Appeared School is required";
    }

    if (!formData.seeAppearedYear) {
      formIsValid = false;
      newErrors["seeAppearedYear"] = "SEE Appeared Year is required";
    }

    if (!formData.gradeAppliedFor) {
      formIsValid = false;
      newErrors["gradeAppliedFor"] = "Grade Applied For is required";
    }

    if (!formData.gpa) {
      formIsValid = false;
      newErrors["gpa"] = "GPA is required";
    }

    // New validation logic for fatherName and motherName
    if (!formData.fatherName) {
      formIsValid = false;
      newErrors["fatherName"] = "Father's Name is required";
    }

    if (!formData.motherName) {
      formIsValid = false;
      newErrors["motherName"] = "Mother's Name is required";
    }

    // Set errors state
    setErrors(newErrors);

    if (formIsValid) {
      console.log("Form submitted:", formData);

      // Construct the mailto link
      const mailtoLink = `mailto:hvtcampus@gmail.com?subject=Application%20Form%20Submission&body=${encodeURIComponent(
        JSON.stringify(formData, null, 2)
      )}`;
      console.log("Mailto Link:", mailtoLink);

      window.open(mailtoLink, "_blank");

      // Clear the form data after submission
      setFormData({
        name: "",
        email: "",
        phone: "",
        program: "",
        actionsMarks: "",
        subjectGPA: "",
        seeAppearedSchool: "",
        seeAppearedYear: "",
        gpa: "",
        academicInfo: "",
        schoolAddress: "",
        municipality: "",
        province: "",
        religion: "",
        nationality: "",
        dob: "",
        gender: "",
        gradeAppliedFor: "",
        fatherName: "", // Clear new fields
        motherName: "", // Clear new fields
      });
    } else {
      console.log("Form validation errors:", newErrors);
    }
  };

  const handleDownloadForm = () => {
    const doc = new jsPDF();

    doc.text("HOLY VISION TECHNICAL CAMPUS", 20, 10);
    doc.text("Thapagaun, New Baneshwor, Kathmandu", 20, 20);
    doc.text("01-5244745 | hvtcampus@gmail.com", 20, 30);
    doc.text("Personal Information", 20, 40);
    doc.text(`Name: ${formData.name}`, 20, 50);
    doc.text(`Father's Name: ${formData.fatherName}`, 20, 60); // New field
    doc.text(`Mother's Name: ${formData.motherName}`, 20, 70); // New field
    doc.text(`Email: ${formData.email}`, 20, 80);
    doc.text(`Phone: ${formData.phone}`, 20, 90);
    doc.text(`Municipality: ${formData.municipality}`, 20, 100);
    doc.text(`Province: ${formData.province}`, 20, 110);
    doc.text(`Religion: ${formData.religion}`, 20, 120);
    doc.text(`Nationality: ${formData.nationality}`, 20, 130);
    doc.text(`Date of Birth: ${formData.dob}`, 20, 140);
    doc.text(`Gender: ${formData.gender}`, 20, 150);
    doc.text(`Grade Applied For: ${formData.gradeAppliedFor}`, 20, 160);
    doc.text("Academic Information", 20, 170);
    doc.text(`SEE Appeared Year: ${formData.seeAppearedYear}`, 20, 180);
    doc.text(`SEE Appeared School: ${formData.seeAppearedSchool}`, 20, 190);
    doc.text(`GPA: ${formData.gpa}`, 20, 200);
    doc.save("Application_Form.pdf");
    setDownloaded(true);
  };

  return (
    <div className="min-h-screen md:-mt-16 -mt-7 bg-gray-100 flex items-center justify-center md:py-16">
      <div className="relative bg-white p-8 md:rounded-lg md:shadow-lg md:w-10/12">
        <div className="absolute md:top-8 top-32 right-2 md:right-6">
          <button
            type="button"
            onClick={handleDownloadForm}
            className="bg-green-500 text-white px-4 text-sm md:py-2 py-1 rounded-lg hover:bg-green-600 flex items-center"
          >
            <FontAwesomeIcon icon={faDownload} className="mr-2" />
            Download
          </button>
        </div>
        <header className="mb-6 text-center">
          <h1 className="md:text-2xl text-xl font-semibold">
            HOLY VISION TECHNICAL CAMPUS
          </h1>
          <p className="text-gray-600">Thapagaun, New Baneshwor, Kathmandu</p>
          <p className="text-gray-600">
            01-5244745 |{" "}
            <a href="mailto:hvtcampus@gmail.com" className="text-blue-500">
              hvtcampus@gmail.com
            </a>
          </p>
        </header>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Personal Information Section */}
          <div>
            <h3 className="text-xl font-semibold mb-2">
              Personal Information <span className="text-red-500">*</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-5">
              <div>
                <label className="block text-gray-700">Name *</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.name && (
                  <p className="text-red-500 text-sm">{errors.name}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Father's Name *</label>
                <input
                  type="text"
                  name="fatherName"
                  placeholder="Enter father's name"
                  value={formData.fatherName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.fatherName && (
                  <p className="text-red-500 text-sm">{errors.fatherName}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Mother's Name *</label>
                <input
                  type="text"
                  name="motherName"
                  placeholder="Enter mother's name"
                  value={formData.motherName}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.motherName && (
                  <p className="text-red-500 text-sm">{errors.motherName}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Email *</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.email && (
                  <p className="text-red-500 text-sm">{errors.email}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Phone *</label>
                <input
                  type="text"
                  name="phone"
                  placeholder="Enter your phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.phone && (
                  <p className="text-red-500 text-sm">{errors.phone}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Municipality *</label>
                <input
                  type="text"
                  name="municipality"
                  placeholder="Enter your municipality"
                  value={formData.municipality}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.municipality && (
                  <p className="text-red-500 text-sm">{errors.municipality}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Province *</label>
                <input
                  type="text"
                  name="province"
                  placeholder="Enter your province"
                  value={formData.province}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.province && (
                  <p className="text-red-500 text-sm">{errors.province}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Religion *</label>
                <input
                  type="text"
                  name="religion"
                  placeholder="Enter your religion"
                  value={formData.religion}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.religion && (
                  <p className="text-red-500 text-sm">{errors.religion}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Nationality *</label>
                <input
                  type="text"
                  name="nationality"
                  placeholder="Enter your nationality"
                  value={formData.nationality}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.nationality && (
                  <p className="text-red-500 text-sm">{errors.nationality}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Date of Birth *</label>
                <input
                  type="date"
                  name="dob"
                  value={formData.dob}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.dob && (
                  <p className="text-red-500 text-sm">{errors.dob}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">Gender *</label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                {errors.gender && (
                  <p className="text-red-500 text-sm">{errors.gender}</p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">
                  Grade Applied For *
                </label>
                <select
                  name="gradeAppliedFor"
                  value={formData.gradeAppliedFor}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                  <option value="">Select Grade</option>

                  <option value="HA">HA</option>
                  <option value="Diploma in Pharmacy">
                    Diploma in Pharmacy
                  </option>
                </select>
                {errors.gradeAppliedFor && (
                  <p className="text-red-500 text-sm">
                    {errors.gradeAppliedFor}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">
                  SEE Appeared School *
                </label>
                <input
                  type="text"
                  name="seeAppearedSchool"
                  placeholder="Enter SEE appeared school"
                  value={formData.seeAppearedSchool}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.seeAppearedSchool && (
                  <p className="text-red-500 text-sm">
                    {errors.seeAppearedSchool}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">
                  SEE Appeared Year *
                </label>
                <input
                  type="text"
                  name="seeAppearedYear"
                  placeholder="Enter SEE appeared year"
                  value={formData.seeAppearedYear}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.seeAppearedYear && (
                  <p className="text-red-500 text-sm">
                    {errors.seeAppearedYear}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-gray-700">GPA *</label>
                <input
                  type="text"
                  name="gpa"
                  placeholder="Enter your GPA"
                  value={formData.gpa}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
                {errors.gpa && (
                  <p className="text-red-500 text-sm">{errors.gpa}</p>
                )}
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="text-center">
            <button
              type="submit"
              className="bg-green-500 text-white px-10 py-2  mt-4 rounded-lg hover:bg-green-600"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Apply;
